/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGizmo = createReactComponent("outline", "gizmo", "IconGizmo", [["path", { "d": "M20 19l-8 -5.5l-8 5.5", "key": "svg-0" }], ["path", { "d": "M12 4v9.5", "key": "svg-1" }], ["path", { "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M4 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M20 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

export { IconGizmo as default };
//# sourceMappingURL=IconGizmo.mjs.map
